import React, { useEffect, useState } from 'react';
import { GetViewType } from "../../utils/view-type";
import { useTranslation } from "react-i18next";
import Sort from "../sort/sort";
import Search from "../search/search";
import { Close, DeleteIcon, EditIcon, KeyIcon, MailIcon, RedCloseIcon } from "../../icons/icons";
import Filter from "../filter/filter";

import { Get } from "../../apis/api";
import CustomSelect from "../UI/customSelect/customSelect";
import { useSelector } from 'react-redux';

const NewVisaTable = ({ defaultValue, onchangeJob, onChange , nationality}) => {
  const viewType = GetViewType()
  const { t } = useTranslation();
  const [idModal, setIdModal] = useState(false)
  const [data, setData] = useState(defaultValue || [])
  const [searchTime, setSearchTime] = useState("")
  const [perPage, setPerPage] = useState(10)
  const [jobs, setJobs] = useState([])
  const [loading, setLoading] = useState(false)


  const user = useSelector((state) => state.user.user)



  const isAdmin = user?.role_key === "super_admin"

  const handleList = (page, per_page, search = "") => {
    setLoading(true)
    Get(`agent/profile/crews?q=${search}`).then((res) => {
      console.log({res})
      setData(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  const lng = useSelector((state) => state.common.lng)


  console.log({nationality})

  const handleSearch = (e) => {

    clearTimeout(searchTime)


    let loop = setTimeout(() => {

      handleList(1, perPage, e);

    }, 1000)
    setSearchTime(loop)

  }
  const handleJobs = () => {
    setLoading(true)
    Get(`basic-information/job`).then((res) => {
      setJobs(res?.details?.data?.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    handleJobs()
  }, [])



  useEffect(() => {
    setData(defaultValue)
  }, [defaultValue])

  const handleSort = (e) => {
    console.log(e)
    setData([])
    setTimeout(() => {
      setData(e)
    }, 0)
  }

  return (
    <div className={"my-container"}>
      {
        viewType === "WEB" ?
          <div
            className="relative w-full  bg-white rounded-lg  flex flex-col items-center w-full !mt-5  ">
            <table className="w-full text-sm text-gray-500">
              <thead className="text-xs text-gray-700 uppercase ">
                <tr className={"border-b border-gray-400"}>
                  <th scope="col" className="px-6 py-3 text-left w-4 font-normal text-gray-600 text-sm">
                    <div className={"mt-1"}>
                      {t("row")}
                    </div>
                  </th>
                  <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex "}>
                      <Sort data={data} sortKey={"name"} onSort={(e) => handleSort(e)} />
                      {t("crewName")}
                    </div>
                  </th>


                  <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex "}>
                      {t("jobs")}
                    </div>
                  </th>


                  <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex flex justify-center"}>
                      <Sort data={data} sortKey={"passport_no"} onSort={(e) => handleSort(e)} />
                      {t("passport")}
                    </div>
                  </th>

                  <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex flex justify-center"}>
                      <Sort data={data} sortKey={"nationality"} onSort={(e) => handleSort(e)} />
                      {t("nationality")}
                    </div>
                  </th>
                  <th scope="col" className="px-6 py-3 text-left w-[200px] font-normal text-gray-600 text-sm">
                    <Search onChange={handleSearch} />
                  </th>
                </tr>
              </thead>
              <tbody>

                {data?.map((item, index) => (
                  <tr key={index} className="bg-white border-b border-gray-400">
                    <td className="px-6 py-4 text-center">
                      <div className={"text-gray-500 text-sm mt-1"}>
                        {index + 1}
                      </div>
                    </td>
                    <td className=" py-4 text-start text-primary-400 text-base font-medium">
                      <div className={"mt-1"}>
                        {item.name + " " + item.last_name}
                      </div>
                    </td>

                    <td className=" py-4 text-start text-primary-400 text-base font-medium max-w-10">
                      <div className={"mt-1"}>
                        <CustomSelect
                          options={jobs}
                          placeHolder={"jobs"}
                          label={"jobs"}
                          name={"destination"}
                          onchange={(e) => onchangeJob({ id: item.id, job_id: e.value })}
                        />

                      </div>
                    </td>

                    <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                      <div className={"mt-1 flex justify-center"}>
                        {item.passport_no}
                      </div>
                    </td>


                    <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                      <div className={"mt-1 flex justify-center"}>
                        {lng == 'fa' ? nationality?.find(i => i.id == item.nationality)?.fa_name : nationality?.find(i => i.id == item.nationality)?.en_name}
                      </div>
                    </td>
                    <td className=" py-4 text-right">
                      <div onClick={() => onChange(item.id)} className={"flex justify-center cursor-pointer"}>
                        <DeleteIcon />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          :
          <div className={"grid gap-3 mt-3"}>
            <div className={"bg-white p-3 rounded-lg flex gap-5"}>
              <Filter />
              <div className={"w-full"}>
                <Search onChange={handleSearch} />
              </div>
            </div>
            {
              data?.map((item, index) => {
                return (
                  <div className={"flex p-4 rounded-lg bg-white"}>
                    <div className={"flex w-full"}>
                      <div className={"mx-1 min-w-7"}>{index + 1}</div>
                      <div className={"flex w-full flex-wrap gap-y-8 justify-between"}>
                        <div className={"flex w-full justify-between"}>
                          <div className={"flex w-1/2 flex-col"}>
                            {item.name + " " + item.last_name}
                          </div>

                          <div className={"flex w-1/2 justify-end text-end text-sm"}>{item.passport_no}</div>

                        </div>
                        <div className={"flex w-full justify-between items-center"}>
                          <div className={"mt-1 w-[150px]"}>
                            <CustomSelect
                              options={jobs}
                              placeHolder={"jobs"}
                              label={"jobs"}
                              name={"destination"}
                              onchange={(e) => onchangeJob({ id: item.id, job_id: e.value })}
                            />

                          </div>
                          <div className={"flex justify-center cursor-pointer"}>
                            <DeleteIcon />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
      }

    </div>
  );
};

export default NewVisaTable;
